import React from 'react';

import { useCurrentProjectId } from '@adsk/alloy-provider';
import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';
import { OpenIcon } from '@adsk/alloy-react-icon';
import ProgressRing from '@adsk/alloy-react-progress-ring';

import UnstyledAnchor from '../../../../../UnstyledAnchor';
import { getBaseScheduleFEUrl } from '../../../helpers';
import { useTranslation } from '../../i18n';
import ScheduleCustomErrorState from '../ScheduleCustomErrorState';
import { useScheduleContext } from '../ScheduleProvider';

function ScheduleNoDataEmptyState() {
  const { t } = useTranslation();
  const projectId = useCurrentProjectId();
  const { schedules, onTryAgain } = useScheduleContext();
  const scheduleBaseUrl = getBaseScheduleFEUrl();

  return (
    <div>
      {schedules?.length === 0 ? (
        <div>
          <EmptyState
            illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_EMPTY_GREY}
            title={t('EMPTY_STATE.TITLE')}
            description={t('EMPTY_STATE.SUB_TITLE')}
          >
            <LinkButton
              as={UnstyledAnchor}
              style={{
                display: 'grid',
                alignItems: 'center',
                gridAutoFlow: 'column',
                gridColumnGap: '4px',
              }}
              href={`${scheduleBaseUrl}/projects/${projectId}`}
            >
              {t('EMPTY_STATE.LINK')}

              <OpenIcon size={16} />
            </LinkButton>
          </EmptyState>
        </div>
      ) : onTryAgain === null ? (
        <ProgressRing size={ProgressRing.SIZES.MEDIUM} />
      ) : (
        <ScheduleCustomErrorState
          onTryAgain={onTryAgain}
          title={t('EMPTY_STATE.ERROR_SCHEDULES_TITLE')}
        />
      )}
    </div>
  );
}

export default ScheduleNoDataEmptyState;
